export default "__VITE_ASSET__B0E_DF3Z__"